import MultiSelectVehicleGroups from './MultiSelectVehicleGroups';

export default MultiSelectVehicleGroups;
